export class  Message {
    messageBody: string;
    messageHeader: string;
    messageType: string;
    icon: string;
    iconColor: string;
    duration: number;
    displaySupport: boolean;
    notify: boolean;
  }